import { gql } from '@apollo/client';

export default gql`
  query products($showPlans: Boolean) {
    products(showPlans: $showPlans) {
      id
      name
      internalName
    }
  }
`;
